import { useEffect, useState, useContext } from "react";
import { UserContext } from "../../context/userContext";
import { Link, useNavigate } from "react-router-dom";

import { Alert, Card, Col, Container, Row } from "react-bootstrap";

import { useMutation } from "react-query";
import { API } from "../../config/api";

import heroImage from "../../assets/img/hero-image.png";

function Login() {
  document.title = "Login";

  const navigate = useNavigate();

  const [state, dispatch] = useContext(UserContext);
  const [message, setMessage] = useState();

  const [form, setForm] = useState({
    email: "",
    password: "",
  });

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = useMutation(async (e) => {
    try {
      e.preventDefault();

      const body = JSON.stringify(form);

      const config = {
        headers: {
          "Content-type": "application/json",
        },
      };

      const response = await API.post("/login", body, config);

      if (response.data.status === "success") {
        dispatch({
          type: "LOGIN_SUCCESS",
          payload: response.data.data,
        });

        if (response.data.data.status === "customer") {
          navigate("/user");
        } else if (response.data.data.status === "admin") {
          navigate("/admin");
        } else {
          navigate("/");
        }
      } else {
        const alert = (
          <Alert variant="warning" className="py-1">
            Failed
          </Alert>
        );
        setMessage(alert);
      }
    } catch (error) {
      const alert = (
        <Alert variant="danger" className="py-1">
          {error.response.data.message || error.response.data.error.message}
        </Alert>
      );
      setMessage(alert);
      console.log(error);
    }
  });

  return (
    <>
      <Container className="login-section">
        <Row>
          <Col md={6} className="mb-5">
            <img src={heroImage} alt="heroImage" className="hero-image my-4" />
            <h1>Easy, Fast and Reliable</h1>
            <p className="text-muted mb-5">
              Go shopping for merchandise, just go to dumb merch shopping. the
              biggest merchandise in <strong>Indonesia</strong>
            </p>
            <div>
              <Link to="/" className="fw-bold link-login">
                Login
              </Link>
              <Link to="/register" className="fw-bold link-register">
                Register
              </Link>
            </div>
          </Col>

          <Col
            md={6}
            className="d-flex align-items-center justify-content-center"
          >
            <Card className="card-login p-4">
              <h3 className="fw-bold my-3">Login</h3>
              <form onSubmit={(e) => handleSubmit.mutate(e)}>
                {message && message}
                <input
                  type="email"
                  className="form-control email-login my-4"
                  name="email"
                  placeholder="Email"
                  value={form.email}
                  onChange={handleChange}
                  required
                />
                <input
                  type="password"
                  className="form-control password-login mb-5"
                  name="password"
                  placeholder="Password"
                  value={form.password}
                  onChange={handleChange}
                  required
                />
                <button type="submit" className="fw-bold btn-login w-100">
                  Login
                </button>
              </form>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default Login;
